var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    { staticClass: "detail-view" },
    [
      _c("div", { staticClass: "detail-header" }, [
        _c(
          "button",
          {
            staticClass: "text-button",
            attrs: { type: "button" },
            on: {
              click: function ($event) {
                return _vm.$emit("back")
              },
            },
          },
          [_vm._v("\n      " + _vm._s(_vm.$t("support_back")) + "\n    ")]
        ),
        _c("div", { staticClass: "detail-title" }, [
          _c("h1", [_vm._v(_vm._s(_vm.aqId || _vm.title))]),
          _c("p", [_vm._v(_vm._s(_vm.detailMeta))]),
        ]),
        _c("div", { staticClass: "detail-actions" }, [
          _c("span", { staticClass: "status-badge", class: _vm.statusClass }, [
            _vm._v(_vm._s(_vm.chatStatusText)),
          ]),
          _c(
            "button",
            {
              staticClass: "ghost-button compact",
              attrs: { type: "button" },
              on: {
                click: function ($event) {
                  return _vm.$emit("back")
                },
              },
            },
            [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.$t("support_mark_solved")) +
                  "\n      "
              ),
            ]
          ),
        ]),
      ]),
      _c(
        "div",
        { ref: "messageList", staticClass: "message-list" },
        [
          _vm.ticket.length
            ? _c("div", { staticClass: "message-day" }, [
                _c("span", [_vm._v(_vm._s(_vm.formatDay(_vm.ticket[0].time)))]),
              ])
            : _vm._e(),
          _vm._l(_vm.ticket, function (item, i) {
            return _c(
              "div",
              {
                key: i,
                staticClass: "message",
                class: Number(item.sender) === 1 ? "agent" : "player",
              },
              [
                _c("div", { staticClass: "bubble" }, [
                  _c("div", { staticClass: "message-name" }, [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          Number(item.sender) === 1
                            ? _vm.$t("support_official_support")
                            : _vm.userName
                        )
                      ),
                    ]),
                    _c("time", [_vm._v(_vm._s(_vm.formatClock(item.time)))]),
                  ]),
                  item.message
                    ? _c("div", { staticClass: "bubble-content" }, [
                        _vm._v(_vm._s(item.message)),
                      ])
                    : _vm._e(),
                  _vm.attachmentUrls(item).length
                    ? _c(
                        "div",
                        { staticClass: "message-attachments" },
                        [
                          _vm._l(_vm.attachmentUrls(item), function (url) {
                            return [
                              _vm.hasVideo(url)
                                ? _c("video", {
                                    key: url,
                                    attrs: {
                                      src: url,
                                      controls: "",
                                      playsinline: "",
                                    },
                                  })
                                : _c("img", {
                                    key: url,
                                    attrs: {
                                      src: url,
                                      alt: _vm.$t("support_attachment_preview"),
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.previewImage(url)
                                      },
                                    },
                                  }),
                            ]
                          }),
                        ],
                        2
                      )
                    : _vm._e(),
                ]),
              ]
            )
          }),
        ],
        2
      ),
      _vm.isClosedTicket
        ? _c(
            "div",
            { staticClass: "rating-panel" },
            [
              _c("span", [_vm._v(_vm._s(_vm.$t("support_rate_title")))]),
              _c("el-rate", {
                on: { change: _vm.onRateChange },
                model: {
                  value: _vm.rating,
                  callback: function ($$v) {
                    _vm.rating = $$v
                  },
                  expression: "rating",
                },
              }),
            ],
            1
          )
        : _c(
            "form",
            {
              staticClass: "reply-box",
              on: {
                submit: function ($event) {
                  $event.preventDefault()
                  return _vm.sendMessage.apply(null, arguments)
                },
              },
            },
            [
              _c(
                "div",
                { staticClass: "reply-toolbar" },
                [
                  _c(
                    "el-upload",
                    {
                      staticClass: "reply-upload",
                      attrs: {
                        "show-file-list": false,
                        action: "/",
                        "http-request": _vm.uploadRequest,
                        disabled: _vm.imageUploading,
                      },
                    },
                    [
                      _c(
                        "button",
                        {
                          staticClass: "tool-button",
                          attrs: {
                            type: "button",
                            disabled: _vm.imageUploading,
                          },
                        },
                        [
                          _c("span", {
                            staticClass: "image-icon",
                            attrs: { "aria-hidden": "true" },
                          }),
                          _c("span", [_vm._v(_vm._s(_vm.$t("support_image")))]),
                        ]
                      ),
                    ]
                  ),
                  _c("span", { staticClass: "reply-hint" }, [
                    _vm._v(_vm._s(_vm.$t("support_reply_hint"))),
                  ]),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "reply-row" },
                [
                  _c("el-input", {
                    staticClass: "reply-input",
                    attrs: {
                      type: "textarea",
                      maxlength: "500",
                      autosize: false,
                      placeholder: _vm.$t("support_input_placeholder"),
                    },
                    model: {
                      value: _vm.inputText,
                      callback: function ($$v) {
                        _vm.inputText = $$v
                      },
                      expression: "inputText",
                    },
                  }),
                  _c(
                    "button",
                    {
                      staticClass: "primary-button send-button",
                      attrs: { type: "submit", disabled: _vm.textUploading },
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _vm.textUploading
                              ? _vm.$t("support_sending")
                              : _vm.$t("support_send")
                          ) +
                          "\n      "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ]
          ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.imgPreviewVisible,
            "append-to-body": "",
            width: _vm.isMobile ? "100%" : "60%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.imgPreviewVisible = $event
            },
          },
        },
        [
          _c("div", { staticClass: "img-preview-container" }, [
            _vm.imgPreviewSrc
              ? _c("img", {
                  staticClass: "img-preview",
                  attrs: {
                    src: _vm.imgPreviewSrc,
                    alt: _vm.$t("support_attachment_preview"),
                  },
                })
              : _vm._e(),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }